import { useEndpoint } from '../../../../api/hooks/endpoint/useEndpoint';
import { CUSTOM_FIELD_TABS, getCustomFieldColumnDefinition } from '../../../../schema/custom-field/custom-field.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';

export const CustomFieldsTable = () => {
  const query = useEndpoint('/custom/fields', 'customFields');

  return (
    <EntityTable
      query={query}
      getColumnDefinition={getCustomFieldColumnDefinition}
      entityTabs={CUSTOM_FIELD_TABS()}
      entityName="Meal Category"
      canExport={false}
    />
  );
};
